if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;

          if (this.classList.contains('product-recommendations--pdp')) {
            this.initPdpSlider();
            this.bindPdpCards();
            return;
          }

          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);
        });
    }

    initPdpSlider() {
      const swiperEl = this.querySelector('.product-recommendations__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;
      if (this._pdpSwiper) {
        this._pdpSwiper.destroy(true, true);
        this._pdpSwiper = null;
      }
      this._pdpSwiper = new Swiper(swiperEl, {
        slidesPerView: 3.15,
        spaceBetween: 8,
        roundLengths: true,
        grabCursor: true,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        resizeObserver: false,
        breakpoints: {
          750: {
            slidesPerView: 4.4,
            spaceBetween: 8
          }
        }
      });
    }

    bindPdpCards() {
      this.addEventListener('change', (event) => {
        if (!event.target.matches('.pdp-ctl-card__select')) return;
        const card = event.target.closest('.pdp-ctl-card');
        const addBtn = card?.querySelector('.pdp-ctl-card__add');
        if (!addBtn) return;
        addBtn.dataset.variantId = event.target.value || '';
        addBtn.disabled = !event.target.value || event.target.selectedOptions[0]?.disabled;
      });

      this.addEventListener('click', async (event) => {
        const addBtn = event.target.closest('.pdp-ctl-card__add');
        if (!addBtn || addBtn.disabled) return;
        const variantId = addBtn.dataset.variantId;
        if (!variantId) return;

        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const cartItems = document.querySelector('cart-items');
          const cartElement = cartDrawer || cartItems;
          const sectionsParam =
            cartElement && typeof cartElement.getSectionsToRender === 'function'
              ? cartElement.getSectionsToRender().map((section) => section.section)
              : [];

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          if (sectionsParam.length) {
            formData.append('sections', sectionsParam.join(','));
            formData.append('sections_url', window.location.pathname);
          }

          const addUrl = window.routes?.cart_add_url
            ? `${window.routes.cart_add_url}.js`
            : `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Add to cart failed');

          if (cartDrawer && result.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(result);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          if (typeof updateCartCounters === 'function') updateCartCounters();
          if (typeof updateFreeShipping === 'function') updateFreeShipping();
        } catch (error) {
          addBtn.disabled = false;
        } finally {
          addBtn.classList.remove('is-loading');
          if (addBtn.dataset.variantId) addBtn.disabled = false;
        }
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
